<template>

  <span>
    <div v-if="value">

      <b-alert variant="warning"
               show
               v-if="value.maxAlarmLevel == 'GELB'">
        {{ formatNumberValue(value.temperatur) }}°C / {{ formatNumberValue(value.luftfeuchtigkeit) }}%
      </b-alert>
      <b-alert variant="danger"
               show
               v-else-if="value.maxAlarmLevel == 'ROT'">
        {{ formatNumberValue(value.temperatur) }}°C / {{ formatNumberValue(value.luftfeuchtigkeit) }}%
      </b-alert>
      <b-alert variant="success"
               show
               v-else-if="value.maxAlarmLevel == 'GRUEN'">
        {{ formatNumberValue(value.temperatur) }}°C / {{ formatNumberValue(value.luftfeuchtigkeit) }}%
      </b-alert>

    </div>
    <div v-else-if="ergebnis">

      <b-alert variant="danger"
               show
               v-if="ergebnis.sensor_luftfeuchtigkeit_alarm_level == 'ROT' || ergebnis.alarm_level == 'ROT'">
        {{ formatNumberValue(ergebnis.result_value) }}°C / {{ formatNumberValue(ergebnis.sensor_luftfeuchtigkeit_result_value) }}%
      </b-alert>
      <b-alert variant="warning"
               show
               v-else-if="ergebnis.sensor_luftfeuchtigkeit_alarm_level == 'GELB' || ergebnis.alarm_level == 'GELB'">
        {{ formatNumberValue(ergebnis.result_value) }}°C / {{ formatNumberValue(ergebnis.sensor_luftfeuchtigkeit_result_value) }}%
      </b-alert>
      <b-alert variant="success"
               show
               v-else>
        {{ formatNumberValue(ergebnis.result_value) }}°C / {{ formatNumberValue(ergebnis.sensor_luftfeuchtigkeit_result_value) }}%
      </b-alert>

    </div>
  </span>

</template>
<script>

export default {

  name: 'SensorAlarmColor',
  props: [
    /** das aktuelle Ergebnis des Sensors */
    'value',
    /** Ergebnis als Ergebnis-Objekt aus dem DB */
    'ergebnis',
  ],
  methods: {

    formatNumberValue(value) {

      if (value === null || value === undefined) {
        return ''
      }

      // Sensor-Ergebnisse können Text oder "," als Dezimaltrenner enthalten
      const num = Number(String(value).replace(',', '.'))
      if (isNaN(num)) {
        return ''
      }
      const decimalStr = num.toString().split('.')[1] || ''

      if (decimalStr.length > 2) {
        return num.toFixed(1)
      } else if (decimalStr.length > 0) {
        return num.toString()
      } else {
        return num.toFixed(0)
      }

    }

  }
}

</script>
